import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { TrendingUp } from "lucide-react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid,
} from "recharts";

const KIND_LABEL = { medical: "طبية", behavioral: "سلوكية", injury: "إصابة", other: "أخرى" };
const KIND_COLOR = { medical: "#F43F5E", behavioral: "#F59E0B", injury: "#EF4444", other: "#64748B" };

export default function EmergencyChart() {
  const [series, setSeries] = useState(null);
  useEffect(() => {
    api.get("/stats/emergency-timeline?months=6").then(({ data }) => setSeries(data)).catch(() => {});
  }, []);
  if (!series) return null;
  const total = series.series.reduce((s, x) => s + x.total, 0);
  const data = series.series.map((row) => ({
    month: row.month,
    ...Object.fromEntries(series.kinds.map((k) => [KIND_LABEL[k] || k, row[k] || 0])),
  }));
  return (
    <Card data-testid="emergency-chart" className="border-slate-200/70 card-elevated">
      <CardContent className="p-5">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-xl bg-rose-100 text-rose-700 flex items-center justify-center">
              <TrendingUp className="w-5 h-5" />
            </div>
            <div>
              <div className="font-black text-slate-900">تحليل الطوارئ — آخر ٦ أشهر</div>
              <div className="text-xs text-slate-500">إجمالي التنبيهات: {total}</div>
            </div>
          </div>
        </div>
        <div className="h-56" dir="ltr">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
              <XAxis dataKey="month" tick={{ fill: "#475569", fontSize: 11 }} />
              <YAxis allowDecimals={false} tick={{ fill: "#475569", fontSize: 11 }} />
              <Tooltip contentStyle={{ borderRadius: 12, borderColor: "#E2E8F0" }} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              {series.kinds.map((k) => (
                <Bar key={k} dataKey={KIND_LABEL[k] || k} stackId="a" fill={KIND_COLOR[k]} maxBarSize={40} />
              ))}
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
